import { Component, OnInit } from '@angular/core';
declare const $: any;

@Component({
  selector: 'app-vender-from',
  templateUrl: './vender-from.component.html',
  styleUrls: ['./vender-from.component.css']
})
export class VenderFromComponent implements OnInit {
  title="";
  constructor() { }

  ngOnInit() {
  }
  
}



// WEBPACK FOOTER //
// ./src/app/Pages/manage/vender/vender-from/vender-from.component.ts